<template>
  <HelperMessage>
    <v-icon v-bind="iconProps">mdi-help-circle-outline</v-icon>
    <template #message>{{ msg }}</template>
  </HelperMessage>
</template>

<script>
export default {
  name: "SimpleHelperMsg",
  components: { HelperMessage: () => import("./HelperMessage.vue") },
  props: {
    msg: String,
    colorIcon: { type: String, default: "primary" },
    sizeIcon: { type: String, default: "small" }
  },
  computed: {
    iconProps() {
      return { color: this.colorIcon, [this.sizeIcon]: true };
    }
  }
};
</script>
